import PT_BR_LOCALE from './pt-BR'

export const namespaces = Object.keys(PT_BR_LOCALE) as ReadonlyArray<keyof typeof PT_BR_LOCALE>
